import { useCallback, useState } from "react";
import useWeb3 from "../useWeb3";
import { InstitusionContract,NftPurchaseContract } from "../../utils/contractHelpers";
import { useWeb3React } from "@web3-react/core";
import Environment from "../../utils/Environment";

const InTotalPurchase = () => {

  const [balance, setBalance] = useState(null)
  const { account } = useWeb3React();
  const web3 = useWeb3();
  const tokenAddress = Environment.instituson;
  const contract = InstitusionContract(tokenAddress, web3);


  const inTotalPurchase = useCallback(
    async () => {
 
      try {
        const buy = await contract.methods.totalPurchases().call()
        return buy/10**18;
      } catch (error) {
        throw error;
      }
    },
    [contract, account,web3]
  );
  return { inTotalPurchase: inTotalPurchase };
};
export default InTotalPurchase;